// クリスマス用ヘッダー導線書き換え
function ApplicationShortsHeader() {
  const pass = localStorage.getItem('referrer-a-byts.myshopify.com--special-2025');
  const SidebarMenuNav = document.getElementById('SidebarMenu__Nav--primary');
  if(!SidebarMenuNav) return;
  const SidebarLinkItemFirst = SidebarMenuNav.querySelector('.sidebar-menu-link-item');
  const sidebarMenuLinkList = SidebarMenuNav.querySelector('.sidebar-menu-link-list');
  if(pass) {

    // header
    let newElementCollapsibleButton1 = document.createElement("a");
    newElementCollapsibleButton1.setAttribute("class", "sidebar-menu-link-item");
    let newText1 = document.createTextNode("TOP");
    newElementCollapsibleButton1.appendChild(newText1);
    newElementCollapsibleButton1.setAttribute("href","/");
    newElementCollapsibleButton1.setAttribute("onclick","event.stopPropagation()");

    sidebarMenuLinkList.insertBefore(newElementCollapsibleButton1, SidebarLinkItemFirst);

    let newElementCollapsibleButton2 = document.createElement("a");
    newElementCollapsibleButton2.setAttribute("class", "sidebar-menu-link-item");
    let newText2 = document.createTextNode("ACCESS!");
    newElementCollapsibleButton2.appendChild(newText2);
    newElementCollapsibleButton2.setAttribute("href","/pages/special-christmas");
    newElementCollapsibleButton2.setAttribute("onclick","event.stopPropagation()");

    sidebarMenuLinkList.insertBefore(newElementCollapsibleButton2, SidebarLinkItemFirst);
    
  }
}

// footerも追加
function ApplicationShortsFooter() {
  const pass = localStorage.getItem('referrer-a-byts.myshopify.com--special-2025');
  const FooterNav = document.querySelector('.Footer__Inner');
  if(!FooterNav) return;
  const FooterLinkItemFirst = FooterNav.querySelector('.Linklist__Item');
  const FooterMenuLinkList = FooterNav.querySelector('.Linklist');
  if(pass) {

    // footer
    let newElementListItem1 = document.createElement("li");
    newElementListItem1.setAttribute("class", "Linklist__Item");
    let newElementCollapsibleButton1 = document.createElement("a");
    newElementCollapsibleButton1.setAttribute("class", "Link Link--primary");
    let newText1 = document.createTextNode("TOP");
    newElementCollapsibleButton1.appendChild(newText1);
    newElementCollapsibleButton1.setAttribute("href","/");
    newElementCollapsibleButton1.setAttribute("onclick","event.stopPropagation()");

    newElementListItem1.appendChild(newElementCollapsibleButton1);

    FooterMenuLinkList.insertBefore(newElementListItem1, FooterLinkItemFirst);


    let newElementListItem2 = document.createElement("li");
    newElementListItem2.setAttribute("class", "Linklist__Item");
    let newElementCollapsibleButton2 = document.createElement("a");
    newElementCollapsibleButton2.setAttribute("class", "Link Link--primary");
    let newText2 = document.createTextNode("ACCESS!");
    newElementCollapsibleButton2.appendChild(newText2);
    newElementCollapsibleButton2.setAttribute("href","/pages/special-christmas");
    newElementCollapsibleButton2.setAttribute("onclick","event.stopPropagation()");

    newElementListItem2.appendChild(newElementCollapsibleButton2);

    FooterMenuLinkList.insertBefore(newElementListItem2, FooterLinkItemFirst);
    
  }
}


ApplicationShortsHeader();
ApplicationShortsFooter();